// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2588":"fce1d127b0d2dbdd","6293":"dd526af4ca1cfd8a","7999":"da6654b36b88c663"}[chunkId] + ".js";
};